import React, { Component } from "react";
import AdminUsersComponent from './components/AdminUsersComponent';

import PropTypes from 'prop-types';


export class AdminUsersContainer extends Component {
    constructor (props){
        super(props)
        this.state = {

        }

    }


    render(){
        return(
            <AdminUsersComponent 

            />
        )
    }
          
        
}

AdminUsersContainer.defaultProps={

}
AdminUsersContainer.propTypes = {

}

export default(AdminUsersContainer);